import { getDayJSLocale } from "@tlc/ui/localization/getDayJSLocale";
import { useLanguage } from "../components/Language";
import * as dayjs from "dayjs";

dayjs.locale(getDayJSLocale());

export function useLocalizedShortDate() {
  const { localizedShortDateFormat } = useLanguage();
  return (date?: dayjs.ConfigType) =>
    dayjs(date).format(localizedShortDateFormat);
}
